import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/cn'

/** Horizontal rhythm. Every page region sits inside one of these. */
export function Container({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mx-auto w-full max-w-7xl px-5 sm:px-8', className)}>{children}</div>
}
